import { FunctionComponent } from "react";
import { LTIProvider } from "./LTIProvider";
export const AuthProvider: FunctionComponent = ({ children }) => {
  return <LTIProvider>{children}</LTIProvider>;
};
